// The four class emblems: one stroke-drawn mark per class, on a 64-unit square. The same paths draw
// the brass plaques over the gun rack (canvas Path2D) and the class row of the rack's visor readout
// (inline SVG), so the badge you pick on screen is the badge you see on the wall.
//
//   Gunslinger: a five-point lawman's star in a ring.  Valkyrie: a wing over a lightning bolt.
//   Phantom: a half mask with smoke curling off it.   Juggernaut: a shield with a chevron.

export const EMBLEMS: readonly string[] = [
  // Gunslinger
  'M32 8 L38.2 24.4 L55.6 24.6 L41.8 35.4 L46.8 52.2 L32 42.2 L17.2 52.2 L22.2 35.4 L8.4 24.6 L25.8 24.4 Z M32 2 A30 30 0 1 1 31.9 2',
  // Valkyrie
  'M8 30 C16 14 34 8 56 10 C46 14 40 18 36 24 C44 22 50 22 56 24 C46 28 38 30 30 34 M34 30 L24 46 L34 46 L26 62 L44 40 L34 40 L42 30',
  // Phantom
  'M12 22 C20 16 44 16 52 22 L52 30 C46 40 38 42 32 42 C26 42 18 40 12 30 Z M20 27 L28 29 M44 27 L36 29 M22 48 C18 54 26 56 22 62 M32 48 C28 54 36 56 32 62 M42 48 C38 54 46 56 42 62',
  // Juggernaut
  'M32 4 L56 12 L56 30 C56 46 46 56 32 62 C18 56 8 46 8 30 L8 12 Z M18 26 L32 38 L46 26 M18 38 L32 50 L46 38',
];

/** Inline SVG for the DOM (stroke takes currentColor). */
export function emblemSvg(cls: number, size = 34) {
  return `<svg class="emb" viewBox="0 0 64 64" width="${size}" height="${size}" aria-hidden="true"><path d="${EMBLEMS[cls & 3]}" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linejoin="round" stroke-linecap="round"/></svg>`;
}

/** Stroke an emblem onto a canvas, centred at (cx, cy), `size` across. */
export function drawEmblem(g: CanvasRenderingContext2D, cls: number, cx: number, cy: number, size: number, width: number) {
  g.save();
  g.translate(cx - size / 2, cy - size / 2);
  g.scale(size / 64, size / 64);
  g.lineWidth = width * (64 / size);
  g.lineJoin = 'round'; g.lineCap = 'round';
  g.stroke(new Path2D(EMBLEMS[cls & 3]));
  g.restore();
}
